<template>
  <v-app>
    <router-view/>
    <v-footer
      class="z-index"
      dark
      padless
    >
      <v-card
        class="flex"
        flat
        tile
        fluid
      >
        <v-card-title class="blue-grey lighten-5">
          <a href="https://www.ozonhealthlabo.com/"><img src="./assets/ozone_logo.png" width=200px></a>

          <v-spacer></v-spacer>

          <div class="caption black--text">株式会社オゾンヘルスケアラボラトリー
            <br>〒 232-0004
            <br>神奈川県横浜市南区前里町1-4-3-3F
            <br>Tel:045-315-6860&nbsp;平日：10:00～19:00
          </div>
        </v-card-title>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    links: [
        {text:'ホーム',link:'https://syokuba-km.com/'},
        {text:'サイト利用規約',link:'https://syokuba-km.com/sitepolicy/'},
        {text:'個人情報保護方針',link:'https://syokuba-km.com/privacy/'},
        {text:'運営会社情報',link:'https://syokuba-km.com/corporate/'},
        {text:'お問い合わせ',link:'https://syokuba-km.com/contact/'}
      ],
  }),
};
</script>

<style scoped>
  .z-index{
    z-index: 102;
  }
</style>